<template>
  <div class="h-full">
    <el-input
      class="search_input"
      v-if="isShowUerInput"
      size="small"
      placeholder="部门或者单位"
      v-model="departName"
      :disabled="disabled"
      clearable
      @clear="clearName"
    >
      <template slot="append">
        <el-button size="small" :disabled="disabled" @click="organDialog = true">选择</el-button>
      </template>
    </el-input>
    <template v-else>
      {{ departName }}
    </template>
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      title="选择单位或部门"
      :visible.sync="organDialog"
      width="560px"
      class="mini-dialog"
      v-dialogDrag
      @open="dialogOpened"
    >
      <el-row :style="{ height: 'calc(100% - 32px)' }" :gutter="10">
        <el-col :span="24" class="h-full">
          <div class="h-full flex flex-col">
            <div class="flex mt-10px mb-10px">
              <el-input
                size="small"
                placeholder="搜索部门"
                v-model="treeKeyword"
                class="mr-5 flex-1"
                clearable
                @keyup.enter.native="searchTreeData"
              ></el-input>
              <el-button
                size="small"
                type="primary"
                @click="$refs.departmentTree.filter(treeKeyword)"
                >搜索</el-button
              >
            </div>
            <!-- check-strictly -->
            <el-tree
              :show-checkbox="showCheckbox"
              class="role-tree flex-auto overflow-y-auto"
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :expand-on-click-node="false"
              :props="defaultTreeProps"
              node-key="id"
              ref="departmentTree"
              :filter-node-method="filterDepartMentNode"
              :default-expanded-keys="defaultExpandIds"
              :default-checked-keys="defaultCheckedIds"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <div slot-scope="{ node }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="text-overflow truncate">
                    {{ node.label }}
                  </p>
                </div>
              </div>
            </el-tree>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer flex justify-center items-center" v-if="showCheckbox">
        <el-button
          :loading="treeLoading"
          size="small"
          type="primary"
          icon="iconfont icon-save"
          @click="handleOk"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="organDialog = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import { OrganizationApi } from '@wiz-api/account'

const organizationApi = new OrganizationApi()
export default {
  name: 'multiple-depart',
  components: {},
  props: {
    // 是否多选
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    // 是否显示内置选择输入框
    isShowUerInput: {
      type: Boolean,
      default: true,
    },
    // 是否禁用选择按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      departName: '',
      searchPeople: null,
      defaultData: null,
      parentIdList: [],
      treeKeyword: '',
      showChangeDepartDialog: false,
      addPepleProps: {
        visible: true,
        title: '添加部门成员',
      },
      defaultDepartExpandIds: [], // 部门目录树默认展开
      defaultDepartCheckedIds: [], // 部门目录树默认选中
      addDepartmentType: 'department',
      showDepartDialog: false,
      peopleProps: {
        visible: false,
        title: '人员详情',
        data: '',
        type: 'edit',
      },
      changeDepartName: {
        visible: true,
        data: '',
      },
      flatArr: [], // 目录树数组扁平化
      defaultCheckedIds: [],
      treeLoading: false,

      treeData: [], // 目录树数据
      defaultTreeProps: {
        children: 'children',
        label: 'displayName',
      },
      defaultExpandIds: [],
      organDialog: false,
    }
  },
  computed: {},
  watch: {
    organDialog(newVal, oldVal) {
      this.treeKeyword = ''
      if (this.value) {
        const list = this.value ? this.value.split(',') : []
        this.$nextTick(() => {
          this.$refs.departmentTree.setCheckedKeys(list)
        })
      }
      this.treeKeyword = ''
      this.$nextTick(() => {
        this.$refs.departmentTree.filter(null)
      })
    },
    value: {
      handler(ids, oldVal) {
        if (!ids) {
          this.departName = ''
        } else {
          this.getDepartName()
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleOk() {
      const list = this.$refs.departmentTree.getCheckedNodes()
      let values
      if (list.length) {
        this.departName = list
          .map((i) => {
            return i.displayName
          })
          .join(',')
        values = list
          .map((i) => {
            return i.id
          })
          .join(',')
      } else {
        this.departName = ''
      }
      this.$emit('change', values)
      this.organDialog = false
    },
    // 过滤树节点
    searchTreeData() {
      this.$refs.departmentTree.filter(this.treeKeyword)
    },
    // 过滤节点
    filterDepartMentNode(value, data) {
      if (!value) return true
      return data.displayName.indexOf(value) !== -1
    },
    // 目录树点击
    async handleDocNodeClick(data, da1, da2) {
      if (this.showCheckbox) return
      this.departName = data.displayName
      this.$emit('change', data.id)
      this.organDialog = false
    },
    clearName() {
      this.departName = ''
      this.$emit('change', '')
      // this.$refs.departmentTree.setCheckedKeys([])
    },
    // 节点展开
    nodeExpand(data) {},
    // 节点关闭
    nodeCollapse(data) {},

    dialogOpened() {},
    // 获取整个目录树
    async getAllTreeListDetails() {
      this.treeLoading = true
      const [err, res] = await organizationApi.getAllListDetails({
        Filter: '',
        Sorting: '',
      })
      if (!err) {
        this.treeData = res.items
        if (this.value) {
          this.defaultExpandIds = this.value.split(',')
        } else {
          this.defaultExpandIds = [res.items[0].id]
        }
        this.getDepartName()
      }
      this.treeLoading = false
    },
    // 获取部门名称
    getDepartName() {
      const list = this.value ? this.value.split(',') : []
      if (!list.length) {
        return
      }
      const promiseList = list.map((id) => {
        return organizationApi.get(id)
      })
      Promise.all(promiseList).then((resList) => {
        this.departName = resList
          .map((item) => {
            const [err, res] = item
            if (err) {
              return ''
            }
            return res.displayName || ''
          })
          .join()
      })
    },
  },
  mounted() {
    this.getAllTreeListDetails()
  },
}
</script>

<style scoped lang="scss">
.search_input {
  ::v-deep input {
    pointer-events: none;
  }
}
.role-tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
::v-deep .el-select-dropdown__item {
  background-color: #ffffff !important;
  overflow: hidden;
  flex-wrap: nowrap;
}
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-input__validateIcon {
  display: none;
}
.vertial-border {
  background-color: #0086f7;
}
</style>
